import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SexFilter } from '../../../../model/patient';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { CacheFilterService } from 'src/app/services/cache/cache-filter.service';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { CountryFilter } from '../../../../model/geography/country-filter';
import { LocalityFilter } from '../../../../model/geography/locality-filter';
import { ProvinceFilter } from '../../../../model/geography/province-filter';
import { GeographyService } from '../../../../services/geography.service';
import { ValidateAutoCompleteSelect } from 'src/app/validators/autocomplete-select.validator';
import { Debounce } from '../../../../decorator/debounce.decorator';
import { CellphoneValidator } from 'src/app/validators/cellphone.validator';
import { ReferringPhysicianEditInfo } from '../../../../model/referring-physician/referring-physician-edit-info';
import { RelevanceReferringPhysicianFilter } from '../../../../model/referring-physician/relevance-referring-physician-filter';
import { PhysicianService } from '../../../../services/physician.service';
import { ReferringPhysicianFilter, ReferringPhysicianSpecialityFilter } from 'src/app/model/referring-physician';
import { referringPhysicianValidator } from '../../../../validators/referring-physician/referring-physician.validator';

@Component({
  selector: 'app-referring-physician-edit-component',
  templateUrl: './referring-physician-edit-control.component.html',
  styleUrls: ['./referring-physician-edit-control.component.css']
})
export class ReferringPhysicianEditControlComponent implements OnInit {

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onClose = new EventEmitter();
  form: FormGroup;
  loadingAction = false;
  loading = false;
  @Input() referringPhysicianId?: number;
  referringPhysicianEditInfo: ReferringPhysicianEditInfo;

  referringPhysicianSpecialityFilters: ReferringPhysicianSpecialityFilter[] = [];
  filterCompleteRelevanceReferringPhysicianFilter: FilterCompleteService<RelevanceReferringPhysicianFilter>;
  filterCompleteSexFilter: FilterCompleteService<SexFilter>;
  filterCompleteCountryFilter: FilterCompleteService<CountryFilter>;
  filterCompleteLocalityFilter: FilterCompleteService<LocalityFilter>;
  filterCompleteProvinceFilter: FilterCompleteService<ProvinceFilter>;

  constructor(private notificationToastService: NotificationToastService
    , private cacheFilterService: CacheFilterService
    , private formBuilder: FormBuilder
    , private geographyService: GeographyService
    , private physicianService: PhysicianService) {

      this.form = this.formBuilder.group({
        LastName: ['', [Validators.required]],
        FirstName: ['', [Validators.required]],
        Sex: ['', [Validators.required, ValidateAutoCompleteSelect]],
        Relevance: ['', [Validators.required, ValidateAutoCompleteSelect]],
        Specialities: ['', [Validators.required]],
        Country: [''],
        Province: [''],
        Locality: [''],
        AddressStreet: [''],
        AddressNumber: [''],
        Floor: [''],
        AddressDpto: [''],
        AddressCP: [''],
        PersonalPhone: [''],
        LaborPhone: [''],
        CellPhone: ['', [new CellphoneValidator()]],
        Email: ['', [Validators.email]],
        NationalRegistration: [''],
        ProvincialRegistration: [''],
        SpecialityRegistration: [''],
        CreateDate: [''],
        CreateUser: [''],
        UpdateDate: [''],
        UpdateUser: [''],
        Valided: [''],
        Checked: [''],
        Deleted: [''],
        Id: [''],
      }, { validator: referringPhysicianValidator.bind(this) });
      this.filterCompleteSexFilter = new FilterCompleteService<SexFilter>([], this.form.controls.Sex);
      this.filterCompleteCountryFilter = new FilterCompleteService<CountryFilter>([], this.form.controls.Country);
      this.filterCompleteRelevanceReferringPhysicianFilter =
      new FilterCompleteService<RelevanceReferringPhysicianFilter>([], this.form.controls.Relevance);
      this.filterCompleteLocalityFilter = new FilterCompleteService<LocalityFilter>([], this.form.controls.Locality);
      this.filterCompleteProvinceFilter = new FilterCompleteService<ProvinceFilter>([], this.form.controls.Province);
    }

  get isValid() {
    return this.form && this.form.valid; }
  get filterCompleteSexFilterOptions() { return this.filterCompleteSexFilter ?
    this.filterCompleteSexFilter.filteredOptions : []; }
    get filterCompleteRelevanceReferringPhysicianOptions() { return this.filterCompleteRelevanceReferringPhysicianFilter ?
        this.filterCompleteRelevanceReferringPhysicianFilter.filteredOptions : []; }
  get filterCompleteCountryFilterOptions() { return this.filterCompleteCountryFilter ?
      this.filterCompleteCountryFilter.filteredOptions : []; }
  get filterCompleteLocalityFilterOptions() { return this.filterCompleteLocalityFilter ?
      this.filterCompleteLocalityFilter.filteredOptions : []; }
  get filterCompleteProvinceFilterOptions() { return this.filterCompleteProvinceFilter ?
      this.filterCompleteProvinceFilter.filteredOptions : []; }
  get f() { return this.form.controls; }

  getReferringPhysicianEditInfo(): ReferringPhysicianEditInfo {
   if (this.form) {
    return  <ReferringPhysicianEditInfo>this.form.getRawValue();
   } else { return null; }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      if (this.referringPhysicianId) {
        this.referringPhysicianEditInfo = await this.physicianService.getReferringPhysicianEditInfo(this.referringPhysicianId);
        if (this.referringPhysicianEditInfo) {
          this.form.patchValue({
            LastName: this.referringPhysicianEditInfo.LastName,
            FirstName: this.referringPhysicianEditInfo.FirstName,
            Sex: this.referringPhysicianEditInfo.Sex,
            Relevance: this.referringPhysicianEditInfo.Relevance,
            Specialities: this.referringPhysicianEditInfo.Specialities,
            Country: this.referringPhysicianEditInfo.Country,
            Province: this.referringPhysicianEditInfo.Province,
            Locality: this.referringPhysicianEditInfo.Locality,
            AddressStreet: this.referringPhysicianEditInfo.AddressStreet,
            AddressNumber: this.referringPhysicianEditInfo.AddressNumber,
            Floor: this.referringPhysicianEditInfo.Floor,
            AddressDpto: this.referringPhysicianEditInfo.AddressDpto,
            PersonalPhone: this.referringPhysicianEditInfo.PersonalPhone,
            LaborPhone: this.referringPhysicianEditInfo.LaborPhone,
            CellPhone: this.referringPhysicianEditInfo.CellPhone,
            AddressCP: this.referringPhysicianEditInfo.AddressCP,
            Email: this.referringPhysicianEditInfo.Email,
            NationalRegistration: this.referringPhysicianEditInfo.NationalRegistration,
            ProvincialRegistration: this.referringPhysicianEditInfo.ProvincialRegistration,
            SpecialityRegistration: this.referringPhysicianEditInfo.SpecialityRegistration,
            CreateDate: this.referringPhysicianEditInfo.CreateDate,
            CreateUser: this.referringPhysicianEditInfo.CreateUser,
            UpdateDate: this.referringPhysicianEditInfo.UpdateDate,
            UpdateUser: this.referringPhysicianEditInfo.UpdateUser,
            Id: this.referringPhysicianEditInfo.Id,
            Valided: this.referringPhysicianEditInfo.Valided,
            Checked: this.referringPhysicianEditInfo.Checked,
            Deleted: this.referringPhysicianEditInfo.Deleted,
          });
        }
      }
      // cargo los combos
      this.loadFiltersComplete();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Edición de médico derivante');
    } finally {
      this.loading = false;
    }
  }

  private loadFiltersComplete(): void {
    this.cacheFilterService.getSexFilters().then((sexFilters) => {
      this.filterCompleteSexFilter = new FilterCompleteService<SexFilter>(
        sexFilters, this.form.controls.Sex);
    });
    this.cacheFilterService.getCountryFilters().then((countryFilters) => {
      this.filterCompleteCountryFilter = new FilterCompleteService<CountryFilter>(
        countryFilters, this.form.controls.Country);
    });

    this.cacheFilterService.getReferringPhysicianSpecialityFilters().then((specialityFilters) => {
      this.referringPhysicianSpecialityFilters = specialityFilters;
    });

    this.loadRelevanceFilters();

    if (this.form.controls.Country.value) {this.loadProvinceFilters(); }
  }

  private loadProvinceFilters(): void {
    if (this.form.controls.Country.value) {
      this.geographyService.getProvinceFilters(this.form.controls.Country.value.Id, '').then((provinceFilters) => {
        this.filterCompleteProvinceFilter = new FilterCompleteService<ProvinceFilter>(
          provinceFilters, this.form.controls.Province);
      });
    }
  }

  private loadRelevanceFilters(): void {
      this.cacheFilterService.getRelevanceReferringPhysicianFilters().then((relevances) => {
        this.filterCompleteRelevanceReferringPhysicianFilter = new FilterCompleteService<RelevanceReferringPhysicianFilter>(
          relevances, this.form.controls.Relevance);
      });
  }

  @Debounce(600)
  onLocalityChange(value: string): void {
    if (this.form.controls.Province.value) {
      this.geographyService.getLocalityFilters(this.form.controls.Province.value.Id, value).then((localityFilters) => {
        this.filterCompleteLocalityFilter = new FilterCompleteService<LocalityFilter>(
          localityFilters, this.form.controls.Locality);
      });
    }
  }

  onProvinceChange(): void {
    this.form.patchValue({ Locality: null });
  }

  provinceSelected(province: ProvinceFilter) {
    this.form.patchValue({ Province: province, Locality: null });
  }

  onCountryChange(): void {
    this.form.patchValue({ Province: null, Locality: null });
  }

  countrySelected(country: CountryFilter) {
    this.form.patchValue({ Country: country, Province: null, Locality: null });
    this.loadProvinceFilters();
  }

  close(): void {
    this.onClose.emit(null);
  }

  async save() {
    if (this.isValid) {
      try {
        this.loadingAction = true;
        const referringPhysicianEditInfo = this.getReferringPhysicianEditInfo();
        const referringPhysicianId = await this.physicianService.referringPhysicianUpdate(referringPhysicianEditInfo);
        const referringPhysicianFilter = new ReferringPhysicianFilter();
        referringPhysicianFilter.Id = referringPhysicianId;
        referringPhysicianFilter.FirstName = referringPhysicianEditInfo.FirstName;
        referringPhysicianFilter.LastName = referringPhysicianEditInfo.LastName;
        if (referringPhysicianEditInfo.NationalRegistration) {
          referringPhysicianFilter.Enrollment = 'MN ' + referringPhysicianEditInfo.NationalRegistration;
        } else if (referringPhysicianEditInfo.ProvincialRegistration) {
          referringPhysicianFilter.Enrollment = 'MP ' + referringPhysicianEditInfo.ProvincialRegistration;
        } else {
          referringPhysicianFilter.Enrollment =  'ME ' + referringPhysicianEditInfo.SpecialityRegistration;
        }
        referringPhysicianFilter.Name = referringPhysicianEditInfo.LastName + ', ' + referringPhysicianFilter.FirstName;
        this.onClose.emit(referringPhysicianFilter);
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Edición de médico derivante');
      } finally {
        this.loadingAction = false;
      }
    }
  }
}
